import React, { useEffect, useRef } from 'react';

if (typeof document !== 'undefined') {
  document.documentElement.classList.add('js-reveal-ready');
}

const forceReveal = (el) => {
  if (!el) return;
  el.classList.add('in');
  el.style.opacity = '1';
  el.style.transform = 'none';
  el.querySelectorAll(':scope > *').forEach((child) => {
    child.style.opacity = '1';
    child.style.transform = 'none';
  });
};

const Reveal = ({ children, as: Tag = 'div', stagger = false, threshold = 0.05, style, className = '', ...rest }) => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hidden = typeof document !== 'undefined' && document.visibilityState === 'hidden';
    if (reduce || hidden) { forceReveal(el); return; }

    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('in');
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold });
    io.observe(el);

    const safety = setTimeout(() => forceReveal(el), 1500);
    const onVisibility = () => {
      if (document.visibilityState === 'hidden' && !el.classList.contains('in')) forceReveal(el);
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => { io.disconnect(); clearTimeout(safety); document.removeEventListener('visibilitychange', onVisibility); };
  }, [threshold]);

  const cls = (stagger ? 'reveal-stagger ' : 'reveal ') + className;
  return <Tag ref={ref} className={cls} style={style} {...rest}>{children}</Tag>;
};

export default Reveal;
